{
    "RunondayMonthLabel": "Executar no dia (mês):",
    "RunondayWeekLabel": "Executar no dia (semana):",
    "RunondaysLabel": "Executar relatório em dias:",
    "RunbetweenhoursStartLabel": "Executar entre horas:",
    "RunbetweenhoursEndLabel": "E:",
    "RunbetweenhoursNote": "(Incluído em toda a hora de término)",
    "RunatminuteHourLabel": "Executar no minuto (hora):",
    "RunatminuteHourNote": "Passado a cada hora (aproximado)",
    "RunondateLabel": "Executar relatório na data:",
    "RunattimeLabel": "Executar no tempo (aproximadamente):",
    "TimeOptions_SectionHeader": "Opções de horário",
    "NAME": "TimeOptions"
}